module.exports = __webpack_public_path__ + "img/cmdb7.abbf35d9.png";